import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon BellIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const BellIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 506 617">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M480.56,417.49c20.88,19.51,33.29,45.51,17,69.51c-6.45,9.5-15.63,13.48-20.5,15 c-6.17,1.93-14.71,1.77-24.26,1.6c-2.91-0.06-5.82-0.1-8.74-0.1c-45.64,0-100.97,0.1-100.97,0.1c0,74.89-48.53,113.39-91.26,113.39 S159.5,577,163.58,503.6c0,0-78.28,0.12-118.52,0.4c-24.5,0.17-34.29-11-38.5-17.5c-6.47-10-16.5-36.5,17.5-69.5 c10-9.71,28.5-48,28.5-76.01c0-21.12,0.13-35.94,0.25-50.64c0.12-14.45,0.25-28.78,0.25-48.85c0-16.01,4.8-35,10-51.01 c32.5-100,124.5-124.99,124.5-124.99c0-44.5,33.5-65.5,65-65.5s63.5,20,65,65.5c0,0,91,25.5,125,124.99 c4.49,13.15,8.09,32.11,9.5,51.51l0,105.99C452.06,380.99,457.06,395.53,480.56,417.49L480.56,417.49z M448,455.99H58 c0,0,28-32.49,38.5-74.99c8.21-33.23,7.37-62.45,6.58-90c-0.51-17.64-1-34.6,0.92-51.5c12.51-110.17,108.61-129.89,131.62-134.61 c0.7-0.14,1.32-0.27,1.88-0.39V62c0-3,3.5-12,15-12s15.02,7,15.5,12c1,10.5,1,26.5,1,42.5c34,5.5,129.44,36,134,147 c1.34,32.55,0.8,52.97,0.37,69.56c-0.54,20.61-0.93,35.29,2.63,59.94C413,429.5,448,455.99,448,455.99z M218,536h75 c-4.11,15.22-16.44,34-35.45,34C230.84,570,220.05,550.21,218,536z"
      />
    </Icon>
  )
}
export default BellIcon
